import { render, staticRenderFns } from "./toBeRegraded.vue?vue&type=template&id=0918aaf6&scoped=true"
import script from "./toBeRegraded.vue?vue&type=script&lang=js"
export * from "./toBeRegraded.vue?vue&type=script&lang=js"
import style0 from "./toBeRegraded.vue?vue&type=style&index=0&id=0918aaf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0918aaf6",
  null
  
)

export default component.exports